/**
 * @desc 查询投诉信息分页列表
 */
import {
  PageComplaintEntity,
  ComplaintQuery
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryOperationComplaintPageParameter = ComplaintQuery

const method = 'GET'
const url = '/trade/operation/complaint/page'

export const queryOperationComplaintPageApi = (
  params?: QueryOperationComplaintPageParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PageComplaintEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryOperationComplaintPageApi.method = method
queryOperationComplaintPageApi.url = url
